import Constants from '../utils/consts';

var http = require('follow-redirects').https;
var fs = require('fs');
var qs = require('querystring');

export default async function createNewDatabase(uname, token, ragSoc, logo, dbName, adminUser, adminPass, billingUser, billingPass) {
    return new Promise(function (resolve, reject) {

        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': Constants.apisFolder + 'createDatabase.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            const resp = JSON.parse(body.toString());
            resolve(resp);
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
            'token': token,
            'uname': uname,
            'ragione_sociale': ragSoc, 
            'logo': logo,
            'db_name': dbName, 
            'main_color': '#F58320',
            'secondary_color': '#FFC260', 
            'user_admin': adminUser, 
            'pass_admin': adminPass,
            'user_billing': billingUser, 
            'pass_billing': billingPass
        });

        req.write(postData);

        req.end();
    });
}
